var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05701 10.9353C7.7758 10.63 7.29895 10.6087 6.99328 10.8926C6.68761 11.1735 6.66621 11.6498 6.95049 11.9551L10.7408 16.0707C10.8783 16.2203 11.074 16.3089 11.2788 16.3119C11.2849 16.3119 11.291 16.3119 11.2941 16.3119C11.4927 16.3119 11.6853 16.2325 11.8259 16.0921L21.424 6.52968C21.7174 6.23658 21.7205 5.76029 21.424 5.46414C21.1305 5.17104 20.6537 5.16798 20.3572 5.46414L11.3155 14.4709L8.05701 10.9353Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.245 11.9731C20.8293 11.9731 20.49 12.309 20.49 12.7273C20.49 17.4047 16.6813 21.2089 11.9985 21.2089C7.31866 21.2089 3.50695 17.4016 3.50695 12.7242C3.50695 8.04987 7.31866 4.24262 11.9985 4.24262C12.4142 4.24262 12.7535 3.90678 12.7535 3.4885C12.7535 3.07327 12.4172 2.73438 11.9985 2.73438C6.48724 2.73743 2 7.21942 2 12.7242C2 18.2321 6.48724 22.711 11.9985 22.711C17.5128 22.711 21.9969 18.229 21.9969 12.7242C22 12.309 21.6607 11.9731 21.245 11.9731Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.dbce2b019764606a450f6f94c42de744.svg";
export { ForwardRef as ReactComponent };